/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { useAgentStatus } from './hooks/useAgentStatus';
import QSModal from '../../shared/components/molecules/modal';
import { ReactComponent as HandIcon } from '../../shared/assets/svg/hand.svg';
import { ReactComponent as InactiveIcon } from '../../shared/assets/svg/inactive.svg';

import { QSButton, QSTypography } from '../../shared/components/atoms';
import { ModalMode } from './state';

export default function AgentAvailabilityModal() {
  const {
    isOnline,
    handleOpenMoreMenu,
    changeStatus,
    isMoreMenuOpen,
    showChangeStatusModal,
    setShowChangeStatusModal,
  } = useAgentStatus();
  return (
    <QSModal
      css={css`
        display: flex;
        justify-content: center;
        align-items: center;
      `}
      open={false}
      onClose={() => setShowChangeStatusModal({ open: false, mode: ModalMode.Session })}
    >
      <div
        css={css`
          background: #fff;
          box-shadow: 0px 11px 15px -7px #00000033;
          box-shadow: 0px 24px 38px 3px #00000024;
          box-shadow: 0px 9px 46px 8px #0000001f;
          gap: 12px;
          padding-top: 16px;
          padding-bottom: 8px;
          border-radius: 4px;
          max-width: 444px;
        `}
      >
        <div
          css={css`
            display: flex;
            align-items: flex-start;
            gap: 12px;
            padding: 0 24px;
          `}
        >
          {showChangeStatusModal?.mode === ModalMode.Session && (
            <HandIcon
              css={css`
                width: 40px;
                height: 40px;
              `}
            />
          )}
          {showChangeStatusModal?.mode === ModalMode.Inactivity && (
            <InactiveIcon
              css={css`
                width: 32px;
                height: 32px;
              `}
            />
          )}
          <div
            css={css`
              display: flex;
              flex-direction: column;
              gap: 8px;
            `}
          >
            <QSTypography
              css={css`
                font-weight: 600;
                font-size: 18px;
                line-height: 140%;
                letter-spacing: 0px;
                color: #2d2d2d;
              `}
            >
              {showChangeStatusModal?.mode === ModalMode.Inactivity
                ? 'Your status has been set to offline'
                : 'You are currently set to offline. Set yourself to Online to start receiving new chats.'}
            </QSTypography>
            <QSTypography
              css={css`
                font-weight: 400;
                font-size: 14px;
                line-height: 140%;
                letter-spacing: 0px;
                color: #666666;
              `}
            >
              {showChangeStatusModal?.mode === ModalMode.Inactivity
                ? 'You have been inactive for more than 5 minutes. Please update your status to continue.'
                : 'You are currently set to offline. Set yourself to Online to start receiving new chats.'}
            </QSTypography>
          </div>
        </div>
        <div
          css={css`
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 12px;
            border-top: 1px solid #e0e0e9;
            padding-top: 8px;
            margin-top: 16px;
            padding-right: 12px;
            padding-left: 12px;
          `}
        >
          <QSButton
            variant="text"
            onClick={() => setShowChangeStatusModal({ open: false, mode: ModalMode.Session })}
            css={css`
              color: #666666;
            `}
          >
            Stay Offline
          </QSButton>
          <QSButton variant="text" color="primary" onClick={() => changeStatus(true)}>
            Go Online
          </QSButton>
        </div>
      </div>
    </QSModal>
  );
}
